import axios from "axios";

const irisClient = axios.create({
  baseURL: import.meta.env.VITE_APP_IRIS_BACK_URL,
  headers: {},
});

const initIrisAuth = (accessToken) => {
  irisClient.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
};

export default irisClient;
export { irisClient, initIrisAuth };
